import logo from '../blockchain.gif';
import './App.css';
import React from "react";
// import { Link } from "react-router-dom";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import UnfairDice from './UnfairDice';
import RockPaperScissors from './RockPaperScissors';
import Australia from './Australia';
import Scale from './Scale';
import CookieClicker from './CookieClicker';
import Mirror from "./Mirror";
import Idiot from "./Idiot";
import Silence from './Silence';
import Sunlight from './Sunlight';
import Nighttime from './Nighttime';
import Age from './Age';
import PayingUsMoney from './PayingUsMoney';
import NonRandomNumber from './NonRandomNumber';
import Calculator from './Calculator';
import WhiteBoard from './WhiteBoard';

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <br />
        <img src={logo} className="App-logo" style={{borderRadius: '50%'}} alt="logo" />
        <p>
          <b>Welcome to Deep Games BlockChain</b>
        </p>
        <a
          className="App-link"
          href="./RockPaperScissors"
          rel="noopener noreferrer"
        >
          Rock Paper Scissors Bot (AI)
        </a>
        <a
          className="App-link"
          href="height"
          rel="noopener noreferrer"
        >
          Height Increaser
        </a>
        <a
          className="App-link"
          href="NonRandomNumber"
          rel="noopener noreferrer"
        >
          Random Number Generator
        </a>

        <a
          className="App-link"
          href="Calculator"
          rel="noopener noreferrer"
        >
          Calculator Simulator
        </a>



        <a
          className="App-link"
          href="Age"
          rel="noopener noreferrer"
        >
          Age Simulator
        </a>
        <a
          className="App-link"
          href="./Scale"
          rel="noopener noreferrer"
        >
          Scale Simulator
        </a>

        <a
          className="App-link"
          href="mirror"
          rel="noopener noreferrer"
        >
          Reversed Mirror Simulator
        </a>
        <a
          className="App-link"
          href="Silence"
          rel="noopener noreferrer"
        >
          Silence Simulator
        </a>
        <a
          className="App-link"
          href="Sunlight"
          rel="noopener noreferrer"
        >
          Sunlight Simulator
        </a>
        <a
          className="App-link"
          href="Nighttime"
          rel="noopener noreferrer"
        >
          Nighttime Simulator
        </a>

        <a
          className="App-link"
          href="PayingUsMoney"
          rel="noopener noreferrer"
        >
          Paying Us Money Simulator
        </a>

        <a
          className="App-link"
          href="WhiteBoard"
          rel="noopener noreferrer"
        >
          WhiteBoard Simulator
        </a>
        <a
          className="App-link"
          href="./UnfairDice"
          rel="noopener noreferrer"
        >
          Dice Simulator
        </a>
        <a
          className="App-link"
          href="./CookieClicker"
          rel="noopener noreferrer"
        >
          Cookie Clicker
        </a>
        <a
          className="App-link"
          href="idiot"
          rel="noopener noreferrer"
        >
          Idiot Simulator
        </a>

        <a
          className="App-link"
          href="https://google.com"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <br />
      </header>
    </div>
  );
}

export default Home;
